import { createStore } from 'vuex'

export default createStore({
  state: {
    list: [],
    userInfo: {},
  },
  mutations: {},
  actions: {},
  modules: {},
})
